import { Icon } from "@/components/ui/icon";
import type { TalentPoolResponse } from "@/lib/api/model";
import { cn } from "@/lib/utils";
import { poolAppearance } from "../lib/appearance";

/** A pool's icon on a soft tile in its color (defaults when unset). */
export function PoolIcon({
  pool,
  size = 20,
  className,
}: {
  pool: Pick<TalentPoolResponse, "kind" | "source" | "is_standard" | "icon" | "color">;
  /** Tile edge in px; the glyph is ~60% of it. */
  size?: number;
  className?: string;
}) {
  const { icon, color } = poolAppearance(pool);
  return (
    <span
      aria-hidden
      data-pool-icon={icon}
      className={cn(
        "flex shrink-0 items-center justify-center rounded-[5px]",
        color.bg,
        color.text,
        className,
      )}
      style={{ width: size, height: size }}
    >
      <Icon name={icon} size={Math.round(size * 0.6)} />
    </span>
  );
}
